module.exports = __webpack_public_path__ + "img/oneSteps.bd58bf86.png";